import React from "react";
import { withRouter } from "../_shared/withRouter";
import TermsComponent from "../template/_common/termsComponent";

const UserTerms = () => {
  return <TermsComponent roleType={"user"} role={"3"} />;
};

export default withRouter(UserTerms);
